import { Button } from "@/ui/shadcn/button";
import { useState, useEffect } from "preact/hooks";

export default function ReplyOptionButton({ replyOption, handleButtonClick, disabled }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (!replyOption.emphasize) return;
    const interval = setInterval(() => {
      setVisible((prev) => !prev);
    }, 750);
    return () => clearInterval(interval);
  }, [replyOption.emphasize]);

  return (
    <div
      key={replyOption.selectionIntent}
      className="relative flex flex-col items-center"
    >
      {replyOption.emphasize && (
        <div
          className={`text-4xl transition-opacity duration-500 ${
            visible ? "opacity-100" : "opacity-0"
          }`}
        >
          👇
        </div>
      )}
      <Button
        variant="taalia_std"
        className="h-9 px-3 text-sm whitespace-nowrap"
        onClick={() => {
          if (!disabled) handleButtonClick(replyOption);
        }}
        disabled={disabled}
      >
        {replyOption.title}
      </Button>
    </div>
  );
}
